import { TrendingUp, Clock, Users, Wrench } from 'lucide-react';
import { Button } from '@/components/ui/button';

const ForBarbers = ({ onBecomeBarber }) => {
  const benefits = [
    {
      icon: <Clock className="w-5 h-5" />,
      text: 'Flexible hours - work when you want'
    },
    {
      icon: <TrendingUp className="w-5 h-5" />,
      text: 'Higher earnings - keep 80%+'
    },
    {
      icon: <Users className="w-5 h-5" />,
      text: 'Get customers delivered to you'
    },
    {
      icon: <Wrench className="w-5 h-5" />,
      text: 'Tools, training & support provided'
    }
  ];

  return (
    <section id="for-barbers" data-testid="for-barbers-section" className="section bg-[var(--bg-secondary)] dark:bg-[#1A1A1A]">
      <div className="container">
        <div className="max-w-6xl mx-auto">
          {/* Banner Card */}
          <div className="relative bg-gradient-to-r from-[#00C167] to-[#009E54] rounded-2xl p-8 md:p-12 lg:p-16 overflow-hidden">
            {/* Decorative Elements */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -translate-y-32 translate-x-32"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-black/10 rounded-full translate-y-24 -translate-x-24"></div>

            {/* Content */}
            <div className="relative z-10">
              <div className="max-w-3xl">
                {/* Badge */}
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/20 backdrop-blur-sm border border-white/30 mb-6" data-testid="barber-badge">
                  <span className="text-white text-xs uppercase font-bold tracking-wider">For Barbers</span>
                </div>

                {/* Headline */}
                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-white mb-4" data-testid="for-barbers-heading">
                  Earn money doing what you love
                </h2>
                <p className="text-lg text-white/90 mb-8 leading-relaxed">
                  Join thousands of barbers earning more with flexible schedules. We bring the customers to you.
                </p>

                {/* Benefits Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8" data-testid="barber-benefits">
                  {benefits.map((benefit, index) => (
                    <div key={index} data-testid={`benefit-${index}`} className="flex items-start gap-3">
                      <div className="flex-shrink-0 w-10 h-10 rounded-full bg-white/20 flex items-center justify-center text-white">
                        {benefit.icon}
                      </div>
                      <span className="text-white font-medium pt-2">{benefit.text}</span>
                    </div>
                  ))}
                </div>

                {/* CTA Button */}
                <Button
                  data-testid="become-barber-button"
                  onClick={onBecomeBarber}
                  size="lg"
                  className="bg-white text-[#00C167] hover:bg-gray-100 font-bold text-lg h-14 px-8"
                >
                  Become a Barber Today
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForBarbers;